import Form from './form'

export default {
  icon: 'font',
  label: 'Dial By Name',
  type: 'voice',
  action: 'dialbyname',
  form: Form
}
